<template>
  <b-list-group-item
    :style="style"
    class="px-2 py-1"
    button
    @click="click"
  >
    <b-row align-v="center">
      <b-col cols="1">
        <TabImage
          v-if="iconPath"
          :story-path="iconPath"
          fixed-width
          :alt="title"
        />
        <b-img
          v-else-if="displayBubblesImage"
          class="small-icon"
          :src="bubblesImg"
          :alt="title"
        />
      </b-col>
      <b-col>
        {{ title }}
      </b-col>
    </b-row>
  </b-list-group-item>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import TabImage from '@/components/public/SideTabs/TabImage.vue'
import bubblesDefault from '@/assets/imgs/bubbles - transparent.png'
import { TreeNode, Path } from '@/types'
import { CSSProperties } from 'vue/types/jsx'

const components = {
  TabImage,
}

const props = {
  suggestionStyle: {
    type: Object as PropType<CSSProperties>,
    default: () => ({}),
  },
  details: {
    type: Object as PropType<TreeNode>,
    required: true,
  },
}

@Component({ components })
export default class ProjectSuggestionItem extends Vue.extend({ props }) {
  get style () {
    return {
      ...this.suggestionStyle,
      'background-color': this.storyColor,
    } as CSSProperties
  }

  get path () {
    return new Path({ parts: this.details.path.parts })
  }

  get storyColor () {
    return this.colour(this.path.level1)
  }

  get iconPath () {
    return this.path.level === 1 && this.path.toString()
  }

  get projectResultFields () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.searchSettings.projectResultFields || []
  }

  get title () {
    if (this.path.level === this.$typedStore.visualisationData.levelCount) {
      return this.projectResultFields
        .map(column => this.details?.data?.[column])
        .join(' - ') ||
        this.details.name
    } else {
      return this.label(this.path) || this.name(this.path)
    }
  }

  get bubblesIcon () {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.navigation.bubblesIcon
  }

  get displayBubblesImage () {
    return this.path.level !== 1 && this.path.level !== this.$typedStore.activeVisualisation.leafLevel
  }

  get bubblesImg () {
    return this.bubblesIcon ? this.bubblesIcon.img ? this.image(this.bubblesIcon.img) : this.bubblesIcon : bubblesDefault
  }

  get colour () {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.nodes.colour
  }

  get name () {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.nodes.name
  }

  get label () {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.nodes.label
  }

  get image () {
    return this.$typedStore.activeVisualisation.visualisationStore.entities.images.image
  }

  click () {
    this.$typedStore.activeVisualisation.updateStoryPath(this.path)
    this.$analytics.event('click', {
      event_category: 'search-project',
      event_label: this.path.toString(),
    })
    this.$typedStore.public.search.setShowModal(false)
  }
}

</script>

<style scoped>
.tab-image {
  width: 2rem;
  font-size: 2rem;
  margin-right: 2rem;
}

.small-icon {
  width: 2rem;
  font-size: 2rem;
}

</style>
